export default __webpack_public_path__ + "static/media/15.874d538f.jpg";